module.exports = __webpack_public_path__ + "img/17_gov3_bc_logo.d331986e.svg";